module.exports = __webpack_public_path__ + "static/media/onama-group 1.27b644ac.png";